import React, { useContext } from 'react';
import {
    View,
    colors,
    Page,
    Grid,
    GridColumn,
    Heading,
    Button,
} from '@fairygodboss/ui';
import { AuthWrapper } from '../../../../../pages/HomePage_v2/sections/components/AuthWrapper';
import { ConvincerSVG } from './ConvincerSVG';
import { PageContext } from '../../../../../contexts/ContextCreator';
import { EmitMetric } from '../../../../Analytics/VisibilityPixel/VisibilityPixel';
import ResponsivePicture from '../../../../Elements/ResponsivePicture/ResponsivePicture';

const Convincer = ({
    miscEventType,
    loginTrigger,
    redirectUrl,
    alwaysDisplayButton,
}) => {
    const onEmitMetirc = () => {
        EmitMetric({
            misc_event_type: miscEventType || 'article_join_footer_button',
            misc_event_count: 1,
        });
    };
    return (
        <View
            display="flex"
            alignItems="center"
            flexDirection="column"
            textAlign="center"
        >
            <GridColumn size={{ xs: 12, sm: 9, md: 6, lg: 10 }}>
                <Heading variant={{ _: 'headingXl', sm: 'heading2xl' }}>
                    Achieve your{' '}
                    <View as="span" color={colors.primary[60]}>
                        career
                    </View>{' '}
                    goals.
                </Heading>
            </GridColumn>
            <GridColumn size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                <Heading
                    variant={{
                        _: 'headingSm',
                        sm: 'headingXs',
                        md: 'headingSm',
                    }}
                    mt="24px"
                >
                    Be part of the largest online career community for women to
                    find jobs, advice, and support — for free.
                </Heading>
            </GridColumn>
            <AuthWrapper
                component={
                    <Button
                        onPress={onEmitMetirc}
                        mt="28px"
                        width="158px"
                        height="56px"
                        px="40px"
                        py="18px"
                        size="medium"
                        fontSize="16px"
                        lineHeight="20px"
                        letterSpacing="-0.4px"
                        alignSelf={{ _: 'auto' }}
                        borderRadius="10px"
                        display={{
                            _: 'inherit',
                            sm: alwaysDisplayButton ? 'inherit' : 'none',
                            md: 'inherit',
                        }}
                        css={{
                            minWidth: '120px',
                            span: {
                                overflow: 'inherit',
                            },
                        }}
                    >
                        Join today!
                    </Button>
                }
                redirectUrl={redirectUrl || '/community/feed'}
                loginTrigger={loginTrigger || 'article_join_footer_button'}
            />
        </View>
    );
};

export const BottomConvincer = ({
    loginTrigger,
    miscEventType,
    redirectUrl,
    alwaysDisplayButton,
    rightAltTag,
    leftAltTag,
}) => {
    const { isLoggedIn } = useContext(PageContext);

    return !isLoggedIn() ? (
        <View
            display="flex"
            width="100%"
            css={{
                fontFamily: 'Open Sans',
                color: colors.neutral[100],
                'image-rendering':
                    '-webkit-optimize-contrast' /* Webkit (non-standard naming) */,
            }}
            pt={{ _: '88px', sm: '80px', md: '96px' }}
            pb={{
                _: '104px',
                sm: alwaysDisplayButton ? '104px' : '114px',
                md: '96px',
            }}
            backgroundColor={colors.info.light}
        >
            <View
                display="flex"
                width="100%"
                flexDirection="column"
                alignItems="center"
            >
                <Page width="100%">
                    <Grid
                        maxWidth="1176px"
                        pl={{ _: '16px', sm: '8px', md: '12px', lg: '12px' }}
                        pr={{ _: '16px', sm: '8px', md: '12px', lg: '12px' }}
                    >
                        <GridColumn
                            size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                            pl="100px"
                            backgroundColor="red"
                            css={{
                                paddingLeft: '0px',
                                paddingRight: '0px',
                                position: 'relative',
                            }}
                        >
                            <GridColumn
                                justifyContent="center"
                                display={{ _: 'flex', md: 'none' }}
                                size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                                pb="24px"
                            >
                                <ConvincerSVG />
                            </GridColumn>

                            <View
                                position="absolute"
                                left="0"
                                display={{ _: 'none', md: '-webkit-box' }}
                                width="100%"
                                top="8px"
                                css={{
                                    pointerEvents: 'none',
                                    img: {
                                        aspectRatio: '424 / 544',
                                    },
                                }}
                            >
                                <GridColumn size={{ md: 3 }}>
                                    <View
                                        css={{
                                            aspectRatio: '425 / 544',
                                            '.component-Elements-Picture': {
                                                display: 'block !important',
                                                height: 'auto !important',
                                            },
                                            img: {
                                                width: '100% !important',
                                                height: 'auto !important',
                                            },
                                        }}
                                    >
                                        <ResponsivePicture
                                            alt={
                                                leftAltTag ||
                                                '"Fairygodboss VIP"'
                                            }
                                            lazyLoad
                                            cloudinaryID="/articles/LeftImage.png"
                                        />
                                    </View>
                                </GridColumn>
                            </View>
                            <Convincer
                                loginTrigger={loginTrigger}
                                miscEventType={miscEventType}
                                redirectUrl={redirectUrl}
                                alwaysDisplayButton={alwaysDisplayButton}
                            />
                            <View
                                position="absolute"
                                right="0"
                                maxWidth="100%"
                                display={{ _: 'none', md: '-webkit-box' }}
                                width="100%"
                                justifyContent="end"
                                top="8px"
                                css={{
                                    pointerEvents: 'none',
                                    img: {
                                        aspectRatio: '526 / 672',
                                    },
                                }}
                            >
                                <GridColumn size={{ md: 3 }}>
                                    <View
                                        css={{
                                            aspectRatio: '526 / 672',
                                            '.component-Elements-Picture': {
                                                display: 'block !important',
                                                height: 'auto !important',
                                            },
                                            img: {
                                                width: '100% !important',
                                                height: 'auto !important',
                                            },
                                        }}
                                    >
                                        <ResponsivePicture
                                            alt={
                                                rightAltTag ||
                                                'Fairygodboss members'
                                            }
                                            lazyLoad
                                            cloudinaryID="/articles/RightImage.png"
                                        />
                                    </View>
                                </GridColumn>
                            </View>
                        </GridColumn>
                    </Grid>
                </Page>
            </View>
        </View>
    ) : null;
};

BottomConvincer.displayName = 'BottomConvincer';
